import { render } from "./humVideoKxjPlayer.vue?vue&type=template&id=7c537ad4&scoped=true"
import script from "./humVideoKxjPlayer.vue?vue&type=script&lang=js"
export * from "./humVideoKxjPlayer.vue?vue&type=script&lang=js"

import "./humVideoKxjPlayer.vue?vue&type=style&index=0&id=7c537ad4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c537ad4"]])

export default __exports__